var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 mt-0 page page-user-item",attrs:{"fluid":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade-flash","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }